import request from "root/js/request";

export const updateMonitoringTraffics = async ({ data }) => {
  const response = await request({
    url: "/monitoring/supplier_article_advert_monitoring/bulk_update/",
    method: "post",
    data,
  });
  return response.data;
};
